import React from 'react';
import { Form } from 'antd';
import type { FormInstance } from 'antd';
import { HTS_INPUT_TYPE_LABELS } from '@/utils/htsInputTypeLabels';
import { BEHAVIOR_CARD_BY_VALUE } from '../htsQuestionWizardConfig';
import { StepHeader } from '../StepHeader';
import type { HtsQuestionFormValues } from '../htsQuestionFormTypes';
import styles from '../HtsQuestionForm.module.scss';

interface Step6ReviewProps {
  form: FormInstance<HtsQuestionFormValues>;
}

export const Step6Review: React.FC<Step6ReviewProps> = ({ form }) => {
  const section: string | undefined = Form.useWatch('section', { form, preserve: true });
  const text: string | undefined = Form.useWatch('text', { form, preserve: true });
  const inputType = Form.useWatch('inputType', { form, preserve: true });
  const behavior = Form.useWatch('behavior', { form, preserve: true });
  const card = behavior ? BEHAVIOR_CARD_BY_VALUE[behavior] : undefined;
  const typeLabel = inputType ? HTS_INPUT_TYPE_LABELS[inputType] : undefined;

  return (
    <div>
      <StepHeader stepNumber={6} title="Review" />
      <div className={styles.reviewSection}>
        {section || 'No section'}
        {typeLabel && ` · ${typeLabel}`}
      </div>
      <div className={styles.reviewText}>{text?.trim() || <em>Untitled question</em>}</div>
      {card && (
        <div className={styles.reviewBehaviorRow}>
          <div className={[styles.behaviorBadge, styles.reviewBadge, styles[`tint-${card.tint}`]].join(' ')}>
            {card.letter}
          </div>
          <span className={styles.reviewBehaviorLabel}>{card.label}</span>
        </div>
      )}
    </div>
  );
};

export default Step6Review;
